import React, {Component} from 'react';
import {validateField} from "../../common/validation";
import {deepCopyObject} from "../../helper/helper";
import NumberFormat from "react-number-format";
import Alert from "react-s-alert";
import {Decimal} from "decimal.js";

class SigortaLines extends Component {
    constructor(props) {
        super(props);
        this.state = {
            trdDocSigortaLines: [],
            trdDocSigortaLinesVisible: [],
        }
        this.addTrdDocSigortaLine = this.addTrdDocSigortaLine.bind(this);
        this.removeTrdDocSigortaLine = this.removeTrdDocSigortaLine.bind(this);
        this.validateField = this.validateField.bind(this);
        this.validateClass = this.validateClass.bind(this);
        this.onValueChange = this.onValueChange.bind(this);
    }

    componentWillMount() {
        let trdDocSigortaLines = deepCopyObject(this.props.trdDocSigortaLines);
        this.setState({
            trdDocSigortaLines: trdDocSigortaLines,
            trdDocSigortaLinesVisible: trdDocSigortaLines
        });
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.trdDocSigortaLines !== nextProps.trdDocSigortaLines) {
            this.setState({trdDocSigortaLines: nextProps.trdDocSigortaLines});
        }
    }

    validateField(e) {
        let id = e.target.id;
        let rule = e.target.dataset.vdata;
        let boundary = e.target.dataset.vlength;
        let result = validateField(rule, boundary, e.target.value);
        let error = this.props.error;
        error = Object.assign(error, {[id]: result});
        this.props.errorListener(error);
    }

    validateClass(id) {
        let error = this.props.error;
        return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
    }

    onValueChange(e, label, index) {
        const {value} = e;
        let trdDocSigortaLines = deepCopyObject(this.state.trdDocSigortaLines);
        let trdDocSigortaLinesVisible = deepCopyObject(this.state.trdDocSigortaLines);
        if((label === "cancelCommissionPrice" || label === "productCommissionPrice") && value==="") {
            trdDocSigortaLinesVisible[index][label] = (new Decimal(0)).toNumber();
            trdDocSigortaLines[index][label] = (new Decimal(0)).toNumber();
        }else {
            trdDocSigortaLinesVisible[index][label] = value;
            trdDocSigortaLines[index][label] = value;
        }
        this.setState({trdDocSigortaLines, trdDocSigortaLinesVisible});
        this.props.listener(trdDocSigortaLines);
    }

    addTrdDocSigortaLine() {
        let trdDocSigortaLines = deepCopyObject(this.state.trdDocSigortaLines);
        trdDocSigortaLines.push({
            recordId: null,
            itemName: '',
            productCommissionPrice: 0.00,
            cancelCommissionPrice: 0.00,
        });
        this.props.listener(trdDocSigortaLines);
        this.setState({trdDocSigortaLines, trdDocSigortaLinesVisible: trdDocSigortaLines});
    }

    removeTrdDocSigortaLine(index){
        let trdDocSigortaLines = deepCopyObject(this.state.trdDocSigortaLines);
        if (trdDocSigortaLines.length === 1) {
            Alert.success("Sigorta en az bir satır içermelidir.", {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 5000
            });
        } else {
            trdDocSigortaLines.splice(index, 1);
            this.props.listener(trdDocSigortaLines);
            this.setState({trdDocSigortaLines ,trdDocSigortaLinesVisible: trdDocSigortaLines});

        }
    }

    render() {
        return (
            <div>
                <div className="card-header row" style={{padding: "15px 5px"}}>
                    <div className="col-sm-4">
                        <h4 className="card-title">Ürün Hizmet Bilgileri</h4>
                    </div>
                    <div className="col-sm-8"
                         style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-end'}}>
                        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', flexWrap: 'wrap'}}>
                            <div style={{padding: '0 2px'}}>
                                <button type="button"
                                        className="TekBtn ekle hizala btn-default btn-md "
                                        onClick={this.addTrdDocSigortaLine}> Satır Ekle
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card-body row" style={{padding: "15px 0"}}>
                    <div className="col-sm-12 ">
                        <div className="" style={{padding: "0 0 0 -1px", width: '100%'}}>
                            <table className="" style={{textAlign: 'center'}}>
                                <thead>
                                <tr style={{backgroundColor: '#ebedf0'}}>
                                    <th width="2%">#</th>
                                    <th width="12%">Açıklama</th>
                                    <th width="12%">İptal Komisyonu</th>
                                    <th width="12%">İstihsal Komisyonu</th>
                                    {this.state.trdDocSigortaLines.length > 1 &&
                                        <th width="4%">İşlemler</th>
                                    }
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    this.state.trdDocSigortaLinesVisible.map((trdDocSigortaLine, index) =>
                                        <tr key={"trdDocSigortaLine_index_" + index}>
                                            <td>{index + 1}</td>
                                            <td>
                                                <input id={'itemName_' + index}
                                                       type="text"
                                                       className="form-control"
                                                       maxLength={255}
                                                       onBlur={this.validateField}
                                                       value={trdDocSigortaLine.itemName}
                                                       placeholder="Açıklama"
                                                       onChange={(e) => e && this.onValueChange({value: e.target.value}, 'itemName', index)}/>
                                            </td>
                                            <td>
                                                <NumberFormat id={'cancelCommissionPrice_' + index}
                                                              value={trdDocSigortaLine.cancelCommissionPrice}
                                                              allowNegative={false}
                                                              isNumericString={true}
                                                              allowEmptyFormatting={false}
                                                              decimalScale={9}
                                                              thousandSeparator={'.'}
                                                              decimalSeparator={','}
                                                              displayType="input"
                                                              placeholder="İptal Komisyonu"
                                                              renderText={value => {
                                                                  value.replace(/\./g, ',')
                                                              }}
                                                              onValueChange={(e) => this.onValueChange(e, 'cancelCommissionPrice', index)}
                                                              className="form-control"/>
                                            </td>
                                            <td>
                                                <NumberFormat id={'productCommissionPrice_' + index}
                                                              value={trdDocSigortaLine.productCommissionPrice}
                                                              allowNegative={false}
                                                              isNumericString={true}
                                                              allowEmptyFormatting={false}
                                                              decimalScale={9}
                                                              thousandSeparator={'.'}
                                                              decimalSeparator={','}
                                                              displayType="input"
                                                              placeholder="İstihsal Komisyonu"
                                                              renderText={value => {
                                                                  value.replace(/\./g, ',')
                                                              }}
                                                              onValueChange={(e) => this.onValueChange(e, 'productCommissionPrice', index)}
                                                              className="form-control"/>
                                            </td>
                                            {this.state.trdDocSigortaLines.length > 1 &&
                                                <td>
                                                        <button type="button" className="Btn temizle" style={{
                                                            margin: "0",
                                                            background: 'linear-gradient(rgba(125, 125, 125, 0.57), rgb(111, 111, 111))'
                                                        }}
                                                                onClick={() => this.removeTrdDocSigortaLine(index)}>
                                                        </button>

                                                </td>
                                            }
                                        </tr>
                                    )
                                }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}

export default SigortaLines;